module.exports = __webpack_public_path__ + "static/media/EnlightenWebBackground4.2169af88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/EnlightenWebBackground4.jpg
// module id = 25
// module chunks = 0